import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import RootState, { State } from '../../../interfaces/RootState'
import SelectField from '../../common/SelectField'

type Props = {
  handleChange: (field: string, value: string) => void,
  values: {
    [key: string]: string
  }
}

const StatesFields: React.FC<Props> = ({ handleChange, values }) => {
  const stateRecords = (state: RootState) => state.login.session.configuration.states
  const states = useSelector(stateRecords)
  const [stateCodes, setStateCodes] = useState(states)

  useEffect(() => {
    const codes = stateCodes.map((stateCode: State) => {
      return { ...stateCode, ...{ value: stateCode.name } }
    })

    setStateCodes(codes)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <SelectField
      name="states"
      label="States"
      options={stateCodes}
      handleChange={handleChange}
      value={values.states}
      multi
    />
  )
}

export default StatesFields
